import { useRef, useState } from 'react';
import { loadCartCompany } from '../Utils/cartApi';
import { ProductRequest } from '../Utils/cartItem';

export function useCartProductRequest(empresa: any, setEmpresa: Function) {
  const [productRequest, setProductRequest] = useState<ProductRequest | null>(null);
  const sequence = useRef(0);
  const currentCompany = useRef(empresa?.pk);
  currentCompany.current = empresa?.pk;
  const chooseProduct = async (productId: string) => {
    const companyId = currentCompany.current;
    const company = await loadCartCompany(companyId);
    if (currentCompany.current !== companyId) return;
    if (!company?.catalogoProdutos?.some((item: any) => item.id === productId)) {
      throw new Error('Este produto não está mais disponível.');
    }
    setEmpresa((current: any) => ({ ...current, ...company }));
    setProductRequest({ productId, requestId: ++sequence.current });
  };
  return { productRequest, chooseProduct };
}
